import React, { useEffect, useState, useContext } from "react";
import { Grid, Typography, makeStyles, withStyles } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { updateData } from "../model/e_meter_alert_service";
import { e_meterAlertsDataCount,e_updateDotApiCount } from "../model/e_meter_alerts_action";
import { Chip } from "@material-ui/core";
import { routePaths } from "../../config/route-paths";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import { notificationDot } from "../../layout/notification/model/notification.reducer";

const useStyle = makeStyles((theme) => ({
  accordionMargin: {
    padding: "0.3rem 0.6rem",
    width: "99% !important"
  },
  accordionSmall: {
    padding: "0.3rem 0",
    width: "98% !important"
  },
  unreadStyle: {
    borderLeft: `0.3rem solid ${theme.palette.eTertiary?.base} !important`,
    fontWeight: "bold",
  },
  blueText: {
    color: theme.palette.ePrimary?.base,
    fontWeight: "bold",
    wordWrap: "break-word"
  },
  blackText: {
    color: theme.palette.eRich?.base,
    fontWeight: "bold",
    wordWrap: "break-word"
  },
  unreadChipStyle: {
    background: theme.palette.eTertiary?.base,
    color: theme.palette.eWhite?.base,
    margin: "0 auto",
    fontSize: "0.6rem",
    height: "1.25rem",
  },
  boldUnread: {
    fontWeight: "bold",
  },
  key: {
    paddingRight: "0.25rem"
  },
  value: {
    paddingLeft: "0.25rem",
  }
}));

const Accordion = withStyles((theme) => ({
  root: {
    border: "1px solid " + theme.palette.eLight?.base,
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
}))(MuiAccordion);

const AccordionSummary = withStyles((theme) => ({
  root: {
    borderBottom: "1px solid " + theme.palette.eLight?.base,
    marginBottom: -1,
    minHeight: "auto",
    height: "37px",
    "&$expanded": {
      minHeight: 40,
    },
  },
  content: {
    margin: "0% 1%",
    width: "80%",
    "&$expanded": {
      margin: "0% 1%",
    },
  },
  expanded: {
    height: "auto",
  },
}))(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: "8px 17px",
  },
}))(MuiAccordionDetails);

export default function E_Alerts_Data({ item, displayPadding, origin, page, autoOpenData, setAutoOpenData,setAnnLoad ,setMeterLoad,meterLoad,annLoad }) {
  let originLabels = {announcement :"ANNOUNCEMENT",meter:"METER",bill:"BILL",prepaid:"PREPAID",charge:"CHARGE",lowBalance:"LOWBALANCE",minBalance:"MINBALANCE"}
  let classes = useStyle();
  let k = origin === originLabels?.announcement ? item?.AnnouncementId : item?.AlertId;
  let autoOpenId = autoOpenData?.AlertId ? autoOpenData?.AlertId : autoOpenData?.AnnouncementId;

  useEffect(() => {
    if(autoOpenId === k) {
      setTimeout(() => {
        setExpanded(autoOpenId)
        setTimeout(setIsread(1), 3000);
        removeUnread(localStorage.getItem(origin), origin);
      }, 100)
    } else {
      setExpanded(false)
    }
  }, [autoOpenData, item])

  let dispatch = useDispatch();
  const [read, setIsread] = useState();
  const [expanded, setExpanded] = useState(false);

  const {t:labels, ready: labelReady}=useTranslation("label-E_ALERTS_AND_NOTIFICATION")
  let dateTimeFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.DATE_TIME_FORMAT
  );
  let dateFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_FORMAT
  );
  const primaryIdentifier = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER
  );
  const accountId = useSelector(
    (store) => store?.meterDetails?.[primaryIdentifier]
  );
  const browserName = useSelector((store) => store?.browserDetect?.browserName);

  const currencySymbol=useSelector(
    (state)=>state?.parametersWidgets?.ParameterLookup?.E_CURRENCY_CODE
  )

  const addTarget = (announcementDesc) => {
    if(announcementDesc && typeof announcementDesc === 'string'){
    return announcementDesc?.replace(new RegExp("<a",'g'),"<a target='_blank'");
    }
  }
  let count = useSelector((store) => store?.e_meterAlertsDataCount?.data);

  let openc = "";

  const checkAndAdd = (data, field) => {
    let allData = JSON.parse(data);
    let temp = [];
    if (allData?.length !== 0 && allData !== null) {
      let availableItem = [];
      availableItem = allData?.filter((i) =>
        origin === originLabels?.announcement
          ? i.AnnouncementId === item.AnnouncementId
          : i.AlertId === item.AlertId
      );
      if (item?.IsRead === 1) {
        //if read & available in local storage then unread item

        availableItem.length === 0 ? setIsread(1) : setIsread(0);
      } else {
        //if unread then check if not available then push item in localstorage
        availableItem.length === 0 && allData.push(item);
        localStorage.setItem(field, JSON.stringify(allData));
      }
    } else {
      if (temp.indexOf(item) === -1 && item.IsRead === 0) {
        if (
          origin === originLabels?.announcement
            ? item?.AnnouncementId !== Number(openc)
            : item?.AlertId !== Number(openc)
        ) {
          temp.push(item); //if unread and no data in localstorage then add in localstorage
        }
        localStorage.setItem(field, JSON.stringify(temp));
      }
    }
  };

  useEffect(() => {
    if (item) {
      setIsread(item?.IsRead);
    }
  }, [item.IsRead, item]);

  useEffect(() => {
    checkAndAdd(localStorage.getItem(origin), origin);
  }, [item, origin, localStorage.getItem(origin), checkAndAdd]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    if (read === 0 && expanded == false) {
      setTimeout(setIsread(1), 3000); //  after 3 seconds of opening the item, dots gets hidden
      removeUnread(localStorage.getItem(origin), origin);
      dispatch(e_updateDotApiCount({justReadNow:true}))
    }
  };

  useEffect(() => {
   setExpanded(false);
  }, [page])

  const removeUnread = (unReadData, field) => {
    unReadData = JSON.parse(unReadData);
    if (unReadData) {
      updateData(
        origin,
        origin === originLabels?.announcement ? item.AnnouncementId : item.AlertId,
        accountId
      );
      let availableItem = unReadData?.filter((i) =>
        origin === originLabels?.announcement
          ? i.AnnouncementId !== item.AnnouncementId
          : i.AlertId !== item.AlertId
      );
      localStorage.setItem(field, JSON.stringify(availableItem));
      item.IsRead = 1;
      let countItem = count[origin]?.filter((i) =>
        origin === originLabels?.announcement
          ? i.AnnouncementId !== item.AnnouncementId
          : i.AlertId !== item.AlertId
      );
      count[origin] = countItem;
      dispatch(e_meterAlertsDataCount(count));
    }
  };

  return (
    <Grid
      item
      className={
        displayPadding ? classes.accordionMargin : classes.accordionSmall
      }
      xs={12}
    >
      {read !== undefined && (
        <Accordion
          className={read === 0 && classes.unreadStyle}
          expanded={expanded === k}
          onChange={handleChange(k)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id={k}
          >
          {
            labelReady ? 
            <>
            <Typography
              variant="subtitle2"
              noWrap={expanded != k}
              align="left"
              className={read === 0 && classes.boldUnread}
            >
              {moment(
                origin === originLabels?.announcement
                  ? item.StartDate
                  : item.InsertedDateTime
              ).format(dateFormat)}

              {origin === originLabels?.meter
                ? item?.Description && "-" + item.Description
                : origin === originLabels?.bill
                ? item?.amount &&
                  "-" + labels("E_BILL_AMOUNT_TITLE") + "-" + item?.amount
                : origin === originLabels?.announcement
                ? item?.AnnouncementTitle && "-" + item?.AnnouncementTitle
                : item?.Description
                ? "-" + item?.Description.replace("****", routePaths.SELF_HELP)
                : item?.EventType}
            </Typography>
            {read === 0 && (
              <Chip
                className={classes.unreadChipStyle}
                label={labels("E_METER_ALERTS_UNREAD_LABEL")}
                size="small"
              />
            )}
            </>
            : <Skeleton /> }
          </AccordionSummary>
          <AccordionDetails
            style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
          >
            <Grid container>
              {origin === originLabels?.announcement ? (
                <Grid item xs={12}>
                  <Typography
                    variant="caption"
                    className={classes.blueText}
                    dangerouslySetInnerHTML={{
                      __html: addTarget(item?.AnnouncementDescription),
                    }}
                  />
                </Grid>
              ) : null}
              <Grid item xs={6} className={classes.key}>
              {
                labelReady ?
                <Typography variant="caption" className={classes.blackText}>
                  {origin !== originLabels?.announcement
                    ? labels("E_EVENT_CREATED")
                    : ""}
                </Typography> : <Skeleton />
              }
              </Grid>
              <Grid item xs={6} className={classes.value}>
                {origin !== originLabels?.announcement ? (
                  <Typography variant="caption" className={classes.blueText}>
                    {moment(item?.CreatedDateTime).format(dateTimeFormat)}
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={6} className={classes.key}>
              {
                labelReady ?
                <Typography variant="caption" className={classes.blackText}>
                  {origin === originLabels?.meter
                    ? item?.meterBadgeNumber && labels("E_METER_BADGE_NUMBER")
                    : origin === originLabels?.bill
                    ? item?.billId && labels("E_BILL_ID")
                    : origin === originLabels?.lowBalance
                    ? item?.thresholdAmt && labels("E_THRESHOLD_AMOUNT")
                    : origin === originLabels?.charge
                    ? item?.amtCharged && labels("E_AMOUNT_CHARGED")
                    : origin === originLabels?.minBalance
                    ? item?.minAmt && labels("E_MIN_BALANCE_MAINTAIN")
                    : ""}
                </Typography> : <Skeleton />
              }
              </Grid>
              <Grid item xs={6} className={classes.value}>
                <Typography variant="caption" className={classes.blueText}>
                  {origin === originLabels?.meter
                    ? item?.meterBadgeNumber
                    : origin === originLabels?.bill
                    ? item?.billId
                    : origin === originLabels?.lowBalance
                    ? currencySymbol + item?.thresholdAmt
                    : origin === originLabels?.charge
                    ? item?.amtCharged
                    : origin === originLabels?.minBalance
                    ? currencySymbol + item?.minAmt
                    : ""}
                </Typography>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}
    </Grid>
  );
}
